import { Permission } from '@today/types'

/** Which API-key controls the viewer may see (TO-516 REQ-015). */
export interface ApiKeyCapabilities {
	/** The Settings section itself. */
	read: boolean
	/** Create and Rename. */
	create: boolean
	revoke: boolean
}

/** The pure permission map: a control the viewer lacks is not rendered. */
export const apiKeyCapabilities = (permissions: readonly string[]): ApiKeyCapabilities => ({
	read: permissions.includes(Permission.API_KEY_READ),
	create: permissions.includes(Permission.API_KEY_CREATE),
	revoke: permissions.includes(Permission.API_KEY_REVOKE),
})
